'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashThrottle = require('lodash.throttle');

var _lodashThrottle2 = _interopRequireDefault(_lodashThrottle);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var ScrollAnimation = (function (_Component) {
  _inherits(ScrollAnimation, _Component);

  function ScrollAnimation(props) {
    _classCallCheck(this, ScrollAnimation);

    _get(Object.getPrototypeOf(ScrollAnimation.prototype), 'constructor', this).call(this, props);

    this.serverSide = typeof window === 'undefined';
    this.listener = (0, _lodashThrottle2['default'])(this.handleScroll.bind(this), 50);

    this.visibility = {
      inViewport: false,
      onScreen: false
    };

    this.state = {
      classes: 'animated',
      style: {
        animationDuration: this.props.duration + 's',
        opacity: this.props.initiallyVisible ? 1 : 0
      }
    };
  }

  _createClass(ScrollAnimation, [{
    key: 'getElementTop',
    value: function getElementTop(elm) {
      var yPos = 0;

      while (elm && elm.offsetTop !== undefined && elm.clientTop !== undefined) {
        yPos += elm.offsetTop + elm.clientTop;
        elm = elm.offsetParent;
      }

      return yPos;
    }
  }, {
    key: 'getScrollPos',
    value: function getScrollPos() {
      if (this.scrollableParent.pageYOffset !== undefined) {
        return this.scrollableParent.pageYOffset;
      }

      return this.scrollableParent.scrollTop;
    }
  }, {
    key: 'getScrollableParentHeight',
    value: function getScrollableParentHeight() {
      if (this.scrollableParent.innerHeight !== undefined) {
        return this.scrollableParent.innerHeight;
      }

      return this.scrollableParent.clientHeight;
    }
  }, {
    key: 'getViewportTop',
    value: function getViewportTop() {
      return this.getScrollPos() + this.props.offset;
    }
  }, {
    key: 'getViewportBottom',
    value: function getViewportBottom() {
      return this.getScrollPos() + this.getScrollableParentHeight() - this.props.offset;
    }
  }, {
    key: 'isInViewport',
    value: function isInViewport(y) {
      return y >= this.getViewportTop() && y <= this.getViewportBottom();
    }
  }, {
    key: 'isAboveViewport',
    value: function isAboveViewport(y) {
      return y < this.getViewportTop();
    }
  }, {
    key: 'isBelowViewport',
    value: function isBelowViewport(y) {
      return y > this.getViewportBottom();
    }
  }, {
    key: 'inViewport',
    value: function inViewport(elementTop, elementBottom) {
      return this.isInViewport(elementTop) || this.isInViewport(elementBottom) || this.isAboveViewport(elementTop) && this.isBelowViewport(elementBottom);
    }
  }, {
    key: 'onScreen',
    value: function onScreen(elementTop, elementBottom) {
      return !this.isAboveScreen(elementBottom) && !this.isBelowScreen(elementTop);
    }
  }, {
    key: 'isAboveScreen',
    value: function isAboveScreen(y) {
      return y < this.getScrollPos();
    }
  }, {
    key: 'isBelowScreen',
    value: function isBelowScreen(y) {
      return y > this.getScrollPos() + this.getScrollableParentHeight();
    }
  }, {
    key: 'getVisibility',
    value: function getVisibility() {
      var elementTop = this.getElementTop(this.node) - this.getElementTop(this.scrollableParent);
      var elementBottom = elementTop + this.node.clientHeight;
      var inViewport = this.inViewport(elementTop, elementBottom);

      return {
        aboveViewport: this.isAboveViewport(elementTop),
        belowViewport: this.isBelowViewport(elementTop),
        inViewport: inViewport,
        onScreen: this.onScreen(elementTop, elementBottom)
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.serverSide) {
        var parentSelector = this.props.scrollableParentSelector;

        this.scrollableParent = parentSelector ? document.querySelector(parentSelector) : window;

        if (this.scrollableParent && this.scrollableParent.addEventListener) {
          this.scrollableParent.addEventListener('scroll', this.listener);
        } else {
          console.warn('Cannot find element by locator: ' + this.props.scrollableParentSelector);
        }
        this.handleScroll();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cleanup();
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      clearTimeout(this.delayedAnimationTimeout);
      clearTimeout(this.callbackTimeout);

      if (window && window.removeEventListener) {
        window.removeEventListener('scroll', this.listener);
      }
    }
  }, {
    key: 'visibilityHasChanged',
    value: function visibilityHasChanged(previousVis, currentVis) {
      return previousVis.inViewport !== currentVis.inViewport || previousVis.onScreen !== currentVis.onScreen;
    }
  }, {
    key: 'captureRef',
    value: function captureRef(ref) {
      if (ref) {
        this.node = ref.animateRef ? ref.animateRef : ref;
      }
    }
  }, {
    key: 'animate',
    value: function animate(animation, callback) {
      var _this = this;

      this.delayedAnimationTimeout = setTimeout(function () {
        _this.animating = true;

        _this.setState({
          classes: 'animated ' + animation,
          style: {
            animationDuration: _this.props.duration + 's'
          }
        });

        _this.callbackTimeout = setTimeout(callback, _this.props.duration * 1000);
      }, this.props.delay);
    }
  }, {
    key: 'animateIn',
    value: function animateIn(callback) {
      var _this2 = this;

      this.animate(this.props.animateIn, function () {
        if (!_this2.props.animateOnce) {
          _this2.setState({
            style: {
              animationDuration: _this2.props.duration + 's',
              opacity: 1
            }
          });
          _this2.animating = false;
        }

        var vis = _this2.getVisibility();
        if (callback) {
          callback(vis);
        }
      });
    }
  }, {
    key: 'animateOut',
    value: function animateOut(callback) {
      var _this3 = this;

      this.animate(this.props.animateOut, function () {
        _this3.setState({
          classes: 'animated',
          style: {
            animationDuration: _this3.props.duration + 's',
            opacity: 0
          }
        });

        var vis = _this3.getVisibility();

        if (vis.inViewport && _this3.props.animateIn) {
          _this3.animateIn(_this3.props.afterAnimatedIn);
        } else {
          _this3.animating = false;
        }

        if (callback) {
          callback(vis);
        }
      });
    }
  }, {
    key: 'shouldNotAnimate',
    value: function shouldNotAnimate(currentVis) {
      if (this.props.animateIn && this.props.animateOut) {
        return !currentVis.onScreen;
      } else if (this.props.animateIn) {
        return !currentVis.onScreen && !currentVis.aboveViewport;
      } else {
        return !currentVis.onScreen && !currentVis.belowViewport;
      }
    }
  }, {
    key: 'shouldAnimateIn',
    value: function shouldAnimateIn(currentVis) {
      if (this.props.animateIn) {
        if (!this.props.animateOut) {
          return currentVis.inViewport || currentVis.aboveViewport;
        } else {
          return currentVis.inViewport;
        }
      }

      return false;
    }
  }, {
    key: 'shouldAnimateOut',
    value: function shouldAnimateOut(currentVis) {
      if (this.props.animateOut && currentVis.onScreen && this.state.style.opacity === 1) {
        if (!this.props.animateIn) {
          return currentVis.inViewport || currentVis.belowViewport;
        } else {
          return currentVis.inViewport;
        }
      }

      return false;
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (!this.animating) {
        // Hack: There seems to be an issue with the way we are doing routing on the learn page, animations, and react component
        // lifecycle events.  For whatever reason, if you navigate quickly from lesson to lesson on the lesson overview page,
        // zombie event listeners are left hanging out observing scroll events.  This hack removes the zombie listeners when detected
        if (!this.node) {
          this.cleanup();
          return true;
        }

        var currentVis = this.getVisibility();

        if (this.visibilityHasChanged(this.visibility, currentVis)) {
          clearTimeout(this.delayedAnimationTimeout);

          if (this.shouldNotAnimate(currentVis)) {
            this.setState({
              classes: 'animated',
              style: {
                animationDuration: this.props.duration + 's',
                opacity: this.props.initiallyVisible ? 1 : 0
              }
            });
          } else if (this.shouldAnimateIn(currentVis)) {
            this.animateIn(this.props.afterAnimatedIn);
          } else if (this.shouldAnimateOut(currentVis)) {
            this.animateOut(this.props.afterAnimatedOut);
          }

          this.visibility = currentVis;
        }
      }
    }
  }, {
    key: 'renderChild',
    value: function renderChild(child, classes) {
      var index = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];
      var _props = this.props;
      var initiallyVisible = _props.initiallyVisible;
      var keepStructure = _props.keepStructure;
      var siblingDelay = _props.siblingDelay;

      var delay = siblingDelay * index;

      var style = Object.assign({}, this.state.style, this.props.style, { animationDelay: delay + 's' });

      return _react2['default'].createElement(
        AnimatedElement,
        {
          classes: classes,
          initiallyVisible: initiallyVisible,
          keepStructure: keepStructure,
          key: index,
          style: style
        },
        child
      );
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren(classes, others) {
      var _this4 = this;

      var _props2 = this.props;
      var children = _props2.children;
      var siblingDelay = _props2.siblingDelay;

      var elem = Array.isArray(others) ? others : children;

      if (siblingDelay && Array.isArray(elem)) {
        return [].concat(_toConsumableArray(Array(elem.length).keys())).map(function (siblingIndex) {
          return _this4.renderChild(elem[siblingIndex], classes, siblingIndex);
        });
      } else {
        return this.renderChild(elem, classes);
      }
    }
  }, {
    key: 'renderWrapped',
    value: function renderWrapped(classes) {
      var _this5 = this;

      return _react2['default'].createElement(
        'div',
        { ref: function (el) {
            _this5.node = el;
          } },
        this.renderChildren(classes)
      );
    }
  }, {
    key: 'renderStructure',
    value: function renderStructure(classes) {
      var _this6 = this;

      var children = this.props.children;

      if (_react2['default'].Children.count(children) === 1) {
        return _react2['default'].Children.map(children, function (child) {
          return _react2['default'].cloneElement(child, { ref: _this6.captureRef.bind(_this6) }, _this6.renderChildren(classes, child.props.children));
        });
      }

      return this.renderWrapped(classes);
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = this.props.className ? this.props.className + ' ' + this.state.classes : this.state.classes;

      if (this.props.keepStructure) {
        return this.renderStructure(classes);
      }

      return this.renderWrapped(classes);
    }
  }]);

  return ScrollAnimation;
})(_react.Component);

exports['default'] = ScrollAnimation;

ScrollAnimation.defaultProps = {
  animateOnce: false,
  delay: 0,
  duration: 1,
  keepStructure: false,
  initiallyVisible: false,
  offset: 150,
  siblingDelay: 0
};

ScrollAnimation.propTypes = {
  animateIn: _propTypes2['default'].string,
  animateOnce: _propTypes2['default'].bool,
  animateOut: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  delay: _propTypes2['default'].number,
  duration: _propTypes2['default'].number,
  initiallyVisible: _propTypes2['default'].bool,
  keepStructure: _propTypes2['default'].bool,
  offset: _propTypes2['default'].number,
  scrollableParentSelector: _propTypes2['default'].string,
  siblingDelay: _propTypes2['default'].number,
  style: _propTypes2['default'].object
};

var AnimatedElement = (function (_Component2) {
  _inherits(AnimatedElement, _Component2);

  function AnimatedElement(props) {
    _classCallCheck(this, AnimatedElement);

    _get(Object.getPrototypeOf(AnimatedElement.prototype), 'constructor', this).call(this, props);

    this.state = {
      hasAnimated: false
    };
  }

  _createClass(AnimatedElement, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this7 = this;

      this.animationEndListener = this.ref.addEventListener('animationend', function () {
        if (_this7.ref) {
          _this7.setState({ hasAnimated: true });
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.ref && this.ref.removeEventListener) {
        this.ref.removeEventListener('animationend', this.animationEndListener);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.style.opacity === 0) {
        this.setState({ hasAnimated: false });
      }
    }
  }, {
    key: 'captureRef',
    value: function captureRef(ref) {
      if (ref) {
        this.ref = ref.animateRef ? ref.animateRef : ref;
      }
    }
  }, {
    key: 'renderStructure',
    value: function renderStructure(_ref) {
      var _this8 = this;

      var style = _ref.style;
      var _props3 = this.props;
      var children = _props3.children;
      var classes = _props3.classes;

      var elem = _react2['default'].Children.map(children, function (child) {
        return _react2['default'].cloneElement(child, { className: classes, style: style, ref: _this8.captureRef.bind(_this8) });
      });

      return elem;
    }
  }, {
    key: 'renderWrapped',
    value: function renderWrapped(_ref2) {
      var _this9 = this;

      var style = _ref2.style;
      var _props4 = this.props;
      var children = _props4.children;
      var classes = _props4.classes;

      return _react2['default'].createElement(
        'div',
        { className: classes, style: style, ref: function (ref) {
            return _this9.ref = ref;
          } },
        children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props;
      var initiallyVisible = _props5.initiallyVisible;
      var keepStructure = _props5.keepStructure;
      var hasAnimated = this.state.hasAnimated;

      var propStyles = this.props.style;

      var opacity = propStyles.animationDelay !== undefined && !initiallyVisible ? 0 : propStyles.opacity;

      var style = Object.assign({}, propStyles, { opacity: hasAnimated ? 1 : opacity });

      if (keepStructure) {
        return this.renderStructure({ style: style });
      }

      return this.renderWrapped({ style: style });
    }
  }]);

  return AnimatedElement;
})(_react.Component);

AnimatedElement.defaultProps = {
  keepStructure: false
};

AnimatedElement.propTypes = {
  classes: _propTypes2['default'].string,
  keepStructure: _propTypes2['default'].bool,
  style: _propTypes2['default'].object
};
module.exports = exports['default'];